export default __webpack_public_path__ + "static/media/diamond.fa759437.png";